import React from "react";
import headshot from "../../headshot.png";
import Typewriter from "../Typewriter";

const SOCIALS = [
  { href: "https://www.linkedin.com/in/josh-pascual/", icon: "fa-brands fa-linkedin", label: "LinkedIn" },
  { href: "https://github.com/joshpas24", icon: "fa-brands fa-github", label: "GitHub" },
  {
    href: "https://docs.google.com/document/d/1FAU2p8rl9nKo99RE8XkXtuzGTlOfC_q8I6qTc5-4g2s/export?format=pdf",
    icon: "fa-regular fa-file",
    label: "Resume",
  },
  { href: "mailto:joshapascual@gmail.com", icon: "fa-regular fa-envelope", label: "Email" },
];

export default function Hero() {
  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center overflow-hidden pt-16"
    >
      <div className="max-w-6xl mx-auto px-6 w-full grid md:grid-cols-[1fr_auto] gap-12 items-center">
        <div className="flex flex-col gap-6 items-center md:items-start text-center md:text-left order-2 md:order-1">
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold tracking-tight text-white">
            Hi, I&apos;m <Typewriter />
          </h1>

          <p className="text-lg md:text-xl text-zinc-400 max-w-xl">
            Technical generalist with a passion for building systems that solve real-world problems.
          </p>

          <div className="flex flex-wrap gap-3 justify-center md:justify-start pt-2">
            <a
              href="#experience"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById("experience")?.scrollIntoView({ behavior: "smooth" });
              }}
              className="px-6 py-3 rounded-full bg-accent hover:bg-accent-dark text-white font-medium transition-colors"
            >
              View my experience
            </a>
            <a
              href="#contact"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
              }}
              className="px-6 py-3 rounded-full border border-white/15 hover:border-white/30 hover:bg-white/5 text-white font-medium transition-colors"
            >
              Get in touch
            </a>
          </div>

          <div className="flex gap-3 pt-2">
            {SOCIALS.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noreferrer"
                title={s.label}
                className="w-11 h-11 rounded-full border border-white/10 text-zinc-300 hover:text-white hover:border-white/30 hover:bg-white/5 flex items-center justify-center transition-colors"
              >
                <i className={s.icon}></i>
              </a>
            ))}
          </div>
        </div>

        <div className="order-1 md:order-2 flex justify-center">
          <div className="relative">
            <div className="absolute inset-0 rounded-full bg-amber-600/40 blur-2xl scale-90" />
            <img
              src={headshot}
              alt="Josh Pascual"
              className="relative w-40 h-40 sm:w-52 sm:h-52 rounded-full object-cover border-2 border-white/10"
            />
          </div>
        </div>
      </div>

      <a
        href="#about"
        onClick={(e) => {
          e.preventDefault();
          document.getElementById("about")?.scrollIntoView({ behavior: "smooth" });
        }}
        className="hidden md:flex absolute bottom-8 left-1/2 -translate-x-1/2 flex-col items-center gap-2 text-zinc-500 hover:text-white transition-colors"
      >
        <span className="text-xs tracking-widest">SCROLL</span>
        <i className="fa-solid fa-chevron-down animate-bounce"></i>
      </a>
    </section>
  );
}
